/* Copyright 2019 The MathWorks, Inc. */

/**
 * The QAB authoring mode can be in one of the 2 modes: DEFAULT or MANUAL.
 *
 *  The "default" QAB authoring mode has the following behavior:
 *  1. A QA Group is automatically created for every Tab Group
 *  2. Any widget that gets added in the QAB is inserted on the left most side of the QA Group
 *  3. Items in the QAB that belong to a contextual tab are shown/hidden based on the corresponding tab group
 *     being added/removed
 *
 *  The "manual" QAB authoring mode has the following behavior:
 *  1. Only Quick Access Bar will be created as a child of Toolstrip
 *  2. There won't be any QA Group created
 *  3. Showing/hiding QAB items logic based on the corresponding tab group being added/removed would be turned off
 *  4. When the user right clicks on a widget and clicks on "Add to Quick Access Toolbar", an event "controlAdded"
 *     would be fired. You need to listen to this event and either create a new QA Group and add correponding QAB
 *     widget to it OR use an existing QA Group and add corresponding QAB widget to it (using UIBuilder APIs "create"
 *     and "createCorrespondingComponentInQAB").
 *
 *  As a result, you will have more control over the QA Groups and also on the correponding QAB widget to be added
 *  to a particular QA Group.
 */

define([], function () {
    return {
        DEFAULT: "default",
        MANUAL: "manual"
    };
});